import { useState } from "react";
import { GetOcrAccountsResponseModel } from "@/features/accounts/ocr/services/get-accounts-model";


export const useGetOcrAccountStates = () => {
  const [ocrAccounts, setOcrAccounts] = useState<GetOcrAccountsResponseModel[]>([]);
  // エラーダイアログ表示フラグ情報
  const [isShowErrorDialog, setIsShowErrorDialog] = useState({
    isError: false,
    errorMessage: "",
    errorCode: "",
  });

  return {
    ocrAccounts,
    setOcrAccounts,
    isShowErrorDialog,
    setIsShowErrorDialog,
  };
};
